import React from 'react';
import styled from 'styled-components';

import { ResultType } from '@williamhill/rosi-ui-shared/src/types';
import { sportsIconsByResultType } from '@williamhill/rosi-ui-shared/src/components/bet-details';

export function ResultIcon({ resultType, marginTop = '0.3rem' }: { resultType?: ResultType; marginTop?: string }) {
  const icon = sportsIconsByResultType[resultType ?? ''];

  if (typeof icon === 'function') {
    const IconComponent = icon;
    return <IconComponent width="1.4rem" style={{ marginTop }} testId="icon-svg" />;
  }
  return (
    <ResultIconStyles color={icon?.color} marginTop={marginTop} data-testid="icon-css">
      {icon?.content ?? ''}
    </ResultIconStyles>
  );
}

const ResultIconStyles = styled.span<{ color?: string; marginTop: string }>`
  display: flex;
  justify-content: center;
  padding: 0.1rem;
  border-radius: 50%;
  font-size: 1rem;
  height: 1.3rem;
  margin-top: ${({ marginTop }) => marginTop};
  width: 1.3rem;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ color, theme }) => theme.colors.modals[color ?? 'neutral']};
`;
